import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = { class: "menu-item px-5 nuevoMiOrganizacion" }
const _hoisted_3 = { class: "menu-text" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center ms-1 ms-lg-3"
}
const _hoisted_5 = {
  class: "btn btn-icon btn-active-light-primary position-relative w-30px h-30px w-md-40px h-md-40px",
  id: "kt_drawer_chat_toggle"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink" }, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "d-flex align-items-center ms-1 ms-lg-3"
}
const _hoisted_9 = {
  class: "btn btn-icon btn-active-light-primary position-relative w-30px h-30px w-md-40px h-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_10 = { class: "svg-icon svg-icon-1" }
const _hoisted_11 = {
  key: 2,
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_12 = {
  class: "cursor-pointer symbol symbol-30px symbol-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_13 = {
  class: "d-flex align-items-center d-lg-none ms-2 me-n3",
  title: "Show header menu"
}
const _hoisted_14 = {
  class: "btn btn-icon btn-active-light-primary",
  id: "kt_header_menu_mobile_toggle"
}
const _hoisted_15 = { class: "svg-icon svg-icon-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_KTNotificationsMenu = _resolveComponent("KTNotificationsMenu")
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/dashboard",
        class: "menu-item me-lg-1"
      }, {
        default: _withCtx(() => [
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.translate("myOrganizations")), 1)
        ]),
        _: 1
      })
    ]),
    (false && _ctx.isAuthenticated)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Group-chat.svg" })
            ]),
            _hoisted_7
          ])
        ]))
      : _createCommentVNode("", true),
    (false && _ctx.isAuthenticated)
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("span", _hoisted_10, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Notifications1.svg" })
            ])
          ]),
          _createVNode(_component_KTNotificationsMenu)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_inline_svg, { src: "/media/Menu40.svg" })
          ]),
          _createVNode(_component_KTUserMenu)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_13, [
      _createVNode("div", _hoisted_14, [
        _createVNode("span", _hoisted_15, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Text/Toggle-Right.svg" })
        ])
      ])
    ])
  ]))
}